import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRectangleHorizontal = (props) => /* @__PURE__ */ _jsx("svg", {
	focusable: "false",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	className: "svg-icon",
	"aria-hidden": "true",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M2 16V8h20v8H2zm2-2h16v-4H4v4z"
	})
});
export default SvgRectangleHorizontal;
